import React, { useEffect, useState } from "react";
import {
  Badge,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Row,
  Table,
  UncontrolledTooltip,
} from "reactstrap";
import SimpleHeader from "../../components/Headers/SimpleHeader";
import { Link } from "react-router-dom";
import useConfirmation from "../../hooks/useConfirmation";
import useNotificationAlert from "../../hooks/useNotificationAlert";
import usePagination from "../../hooks/usePagination";
import Pagination from "../../components/Pagination";
import { useAppDispatch, useAppSelector } from "../../redux/store";
import { destroy, setStatus, updateStatus } from "../../redux/reducers/user";
import { getAll } from "../../redux/reducers/user";
import { statusFromBEMap } from "../../constants/global";
import ModalChangeStatus, { ModalChangeStatusProps } from "./ModalChangeStatus";
import { IUser } from "../../services/userApi/types";

const perPage = 10;
const UserList: React.FC = (props) => {
  const { pageNumber, goToPage } = usePagination({ props });

  const dispatch = useAppDispatch();

  const { isLoadingDatas, paginatedData, isLoadingDestroy, isLoadingSave } =
    useAppSelector((state) => state.user);

  const { show: showNotificationAlert } = useNotificationAlert({
    place: "br",
  });

  useEffect(() => {
    dispatch(getAll());
  }, []);

  const { showConfirmation, hideConfirmation } =
    useConfirmation(isLoadingDestroy);

  const onDelete = async (id: string) => {
    try {
      await dispatch(destroy(id));

      showNotificationAlert({
        title: "Success",
        message: "You have deleted the user successfully",
      });

      await dispatch(getAll());
    } catch (err: any) {
      switch (err.message) {
        default:
          showNotificationAlert({
            type: "danger",
            title: "Failed",
            message: err.message,
          });
          break;
      }
    } finally {
      hideConfirmation();
    }
  };

  const [modalChangeStatus, setModalChangeStatus] =
    useState<ModalChangeStatusProps>({
      isShow: false,
      onSubmit: () => {},
      onClose: () => {},
    });

  {
    /*const onStatusChange = (data: IUser) => {
    setModalChangeStatus((localData) => ({
      ...localData,
      isShow: true,
      customerData: data,
      onSubmit: async ({ status }) => {
        try {
          await dispatch(
            updateStatus({ id: data.id, status: status || "active" })
          );
          setModalChangeStatus(() => ({
            ...modalChangeStatus,
            isShow: false,
          }));
          dispatch(setStatus({ id: data.id, status }));
        } catch (err) {
          console.log("__err", err);
        }
      },
    }));
  };*/
  }

  console.log("__paginatedData123", paginatedData?.data.length);

  return (
    <>
      <ModalChangeStatus
        {...modalChangeStatus}
        isLoadingConfirm={isLoadingSave}
        onClose={() =>
          setModalChangeStatus((localData) => ({ ...localData, isShow: false }))
        }
      />
      <SimpleHeader
        name="User"
        rightElements={
          <>
            <Link
              to="/admin/user/add"
              className="btn btn-neutral btn-sm"
              color="default"
            >
              Add New User
            </Link>
          </>
        }
      />
      <Container className="mt--6" fluid>
        <Row>
          <div className="col">
            <Card>
              <CardHeader className="border-0">
                <Row>
                  <Col>
                    <h3 className="mb-0">List Users</h3>
                  </Col>
                </Row>
              </CardHeader>

              {isLoadingDatas && (
                <CardBody>
                  <p className="text-center">Loading...</p>
                </CardBody>
              )}

              {!isLoadingDatas && !paginatedData?.data.length && (
                <CardBody>
                  <p className="text-center">There is no data!</p>
                </CardBody>
              )}

              {!isLoadingDatas && paginatedData?.data.length && (
                <>
                  <Table
                    className="align-items-center table-flush"
                    responsive
                    striped
                  >
                    <thead className="thead-light">
                      <tr>
                        <th>Full Name</th>
                        <th>Company Name</th>
                        <th>Status</th>
                        <th>Manage</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paginatedData?.data.map((data: IUser) => (
                        <tr key={`data-${data.id}`}>
                          <td>{`${data.first_name} ${data.last_name}`}</td>
                          <td>{data.role}</td>
                          <td>
                            <h4>
                              <Badge
                                color={
                                  data.status === "active"
                                    ? "success"
                                    : "danger"
                                }
                                onClick={() => {
                                  // onStatusChange(data);
                                }}
                              >
                                {statusFromBEMap[data.status]}
                              </Badge>
                            </h4>
                          </td>
                          <td className="table-actions">
                            <div className="d-flex">
                              <Link
                                className="table-action"
                                to={`/admin/user/${data.id}/edit`}
                                id={`tooltip-edit-${data.id}`}
                              >
                                <i className="fas fa-user-edit" />
                              </Link>
                              <UncontrolledTooltip
                                delay={0}
                                target={`tooltip-edit-${data.id}`}
                              >
                                Edit User
                              </UncontrolledTooltip>

                              <button
                                className="table-action table-action-delete"
                                id={`tooltip-delete-${data.id}`}
                                onClick={(e) => {
                                  e.preventDefault();
                                  showConfirmation({
                                    title: "Are you sure want to delete?",
                                    onConfirm: () => onDelete(data.id),
                                  });
                                }}
                              >
                                <i className="fas fa-trash" />
                              </button>
                              <UncontrolledTooltip
                                delay={0}
                                target={`tooltip-delete-${data.id}`}
                              >
                                Delete User
                              </UncontrolledTooltip>
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                  <CardFooter className="py-4">
                    {/*<Pagination
                      totalRow={data.getPresetDataSets?.paginatorInfo.total}
                      perPage={perPage}
                      initialPage={pageNumber - 1}
                      onPageChange={(data) => {
                        goToPage(data);
                      }}
                    />
                    */}
                  </CardFooter>
                </>
              )}
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};

export default UserList;
